import React from 'react';

import { ReactComponent as FileDocumentIcon } from '../assets/icons/file-document.svg';
import { ReactComponent as ImageIcon } from '../assets/icons/image.svg';
import { ReactComponent as VideoIcon } from '../assets/icons/video.svg';

export const isImageType = (type: string): boolean => {
    return /^image\/(jpeg|jpg|png|gif|bmp|svg)$/i.test(type);
};

export const isVideoType = (type: string): boolean => {
    return /^video\//i.test(type);
};

export const getFileIcon = (
    type: string,
    size: { width: number; height: number } = { width: 16, height: 16 }
): React.ReactElement => {
    if (isImageType(type)) {
        return <ImageIcon width={size.width} height={size.height} />;
    } else if (isVideoType(type)) {
        return <VideoIcon width={size.width} height={size.height} />;
    } else {
        return <FileDocumentIcon width={size.width} height={size.height} />;
    }
};
